module.exports = __webpack_public_path__ + "assets/img/a877a7d0e7c2661da37ef3f34d115ab4.png";